"use strict";
import "../../api/api";
const InvoiceAbandonerReason = ({
  error,
  isPaymentsNetworkSubmission,
  onChange,
  selectedOption,
  value
}) => {
  if (selectedOption === "duplicate-invoice") {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, /* @__PURE__ */ React.createElement("label", null, "Reason"), /* @__PURE__ */ React.createElement("textarea", { onChange, value }), error && /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution" }, "Please enter a reason"), isPaymentsNetworkSubmission && /* @__PURE__ */ React.createElement("div", { className: "payments-network__reason" }, "Note: This is a Network Invoice. The factor will be notified that the invoice has been ignored. Please leave a reason."));
};
export default InvoiceAbandonerReason;
